export enum EOwnerType {
	INDIVIDUAL = 'individual',
	LEGAL_ENTITY = 'legal_entity'
}